import request from './service/index'

export function getModuleStatistics_Api(data){//查询列表
  return request({
      url:`CMS/statistics/module_statistics`,
      method:'post',
      data:data
  });
}

export function getHomeStatistics_Api(data){//查询列表
  return request({
      url:`/CMS/statistics/home`,
      method:'post',
      data:data
  });
}

export function getGroupPortrait_Api(data){//查询列表
  return request({
      url:`/CMS/statistics/user_statistics`,
      method:'post',
      data:data
  });
}


export function getModulePageStatistics_Api(data){//查询列表
  return request({
      url:`/CMS/statistics/detail_statistics`,
      method:'post',
      data:data
  });
}


// WEBPACK FOOTER //
// ./src/apis/statistics.api.js